module.exports = __webpack_public_path__ + "static/media/home-icon.9ba63373.svg";